import { render, staticRenderFns } from "./IotGatewayContent.vue?vue&type=template&id=6b8044f4&scoped=true&lang=pug&"
import script from "./IotGatewayContent.vue?vue&type=script&lang=ts&"
export * from "./IotGatewayContent.vue?vue&type=script&lang=ts&"
import style0 from "./IotGatewayContent.vue?vue&type=style&index=0&id=6b8044f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8044f4",
  null
  
)

export default component.exports